import { render, staticRenderFns } from "./BuddleOrder.vue?vue&type=template&id=104dbcad&scoped=true"
import script from "./BuddleOrder.vue?vue&type=script&lang=js"
export * from "./BuddleOrder.vue?vue&type=script&lang=js"
import style0 from "./BuddleOrder.vue?vue&type=style&index=0&id=104dbcad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104dbcad",
  null
  
)

export default component.exports